const Theme = {
  logo_image_url: 'monville.png',
  logo_height: 50,
  token_hidden: true,

  body_background_color: 'white',

  button_color: 'black',
  button_radius: 5,
  button_outlined_as_default: true,

  text_font: `'Roboto', 'sans-serif'`,
  text_color: 'black',
  title_font: `'Roboto', 'sans-serif'`,

  photobooth_button_color: 'white',
  photobooth_button_text_color: 'black',
}

export default Theme
